import { styled } from "@mui/material/styles";
import { AUDIT_TOKENS } from "../../theme/auditTokens";

/** White card with the reference page's 12px radius and hairline border. Use `as` for the tag. */
export const SurfaceCard = styled("div")({
  background: AUDIT_TOKENS.surface,
  border: `1px solid ${AUDIT_TOKENS.line}`,
  borderRadius: AUDIT_TOKENS.radius.card,
});
